const STORAGE_PREFIX = 'evitals-ai-chat:';

export function getAiAssistantChatKey(userId) {
  return `${STORAGE_PREFIX}${userId}`;
}

export function loadAiAssistantChat(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(getAiAssistantChatKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveAiAssistantChat(userId, messages) {
  if (!userId) return;
  try {
    localStorage.setItem(getAiAssistantChatKey(userId), JSON.stringify(messages || []));
  } catch {
    // ignore quota / private mode errors
  }
}

export function clearAllAiAssistantChats() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(STORAGE_PREFIX)) {
        keys.push(key);
      }
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
}
